function handleProductImageCaption() {
  const captionCheck = 'caption'
  const productMedia = document.querySelectorAll('.gdc-custom-media')

  const handleMediaCaption = (media) => {
    const mediaImage = media.querySelector('.image__img')
    const mediaImageAlt = mediaImage && media.querySelector('.image__img').alt.toLowerCase()
    const mediaCaptionDestination = media.querySelector('.gdc-product-image-caption')
    const isCaption = mediaImageAlt && mediaImageAlt.includes(captionCheck)
    
    if (isCaption) {
      const caption = mediaImageAlt.replace(captionCheck, '')
      mediaCaptionDestination.insertAdjacentText('afterbegin', caption)
    }
  }

  productMedia.forEach(media => {  
    handleMediaCaption(media)
  })
}

window.addEventListener('DOMContentLoaded', handleProductImageCaption)